import { render, staticRenderFns } from "./consultation.vue?vue&type=template&id=42d93c0c&scoped=true"
import script from "./consultation.vue?vue&type=script&lang=js"
export * from "./consultation.vue?vue&type=script&lang=js"
import style0 from "./consultation.vue?vue&type=style&index=0&id=42d93c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d93c0c",
  null
  
)

export default component.exports